// Translation: Login > Landing > Form (Ukrainian)
export default Object.freeze({
	form: {
		actions: {
			login: {
				label: ''
			}
		},
		fields: {
			code: {
				placeholder: ''
			},
			email: {
				placeholder: ''
			},
			password: {
				placeholder: ''
			}
		},
		options: {
			register: {
				action: '',
				label: ''
			},
			reset: {
				action: ''
			}
		},
		title: {
			credentials: '',
			twoFactorAuthentication: ''
		}
	}
})
